<template>
	<GenericInput type="text" :maxlength="maxlength" :value="modelValue" class="px-2 py-1" @update:value="updateValue"/>
</template>
<script setup lang="ts">
import GenericInput from '@/Components/UI/Inputs/GenericInput.vue'

defineProps<{
	modelValue:string|null,
	maxlength?:number,
}>()

const emit = defineEmits([
	'update:modelValue',
])

function updateValue(newValue: string){
	emit('update:modelValue', newValue)
}
</script>
